import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'mh-core-lib-video-image-slider',
    templateUrl: './video-image-slider.component.html',
    styleUrls: ['./video-image-slider.component.scss'],
    standalone: false
})
export class CoreLibVideoImageSliderComponent<T> {
  private _items: T[] = [];
  private _currentSlide = 0;
  
  @Input() 
  get items(): T[] {
    return this._items;
  }
  set items(value: T[]) {
    this._items = value;
    this.adjustCurrentSlide();
  }

  @Input() 
  get currentSlide(): number {
    return this._currentSlide;
  }
  set currentSlide(value: number) {
    this._currentSlide = value;
  }

  @Output() updateCurrentSlide = new EventEmitter<number>();
  @Output() resetTimer = new EventEmitter<void>();

  private adjustCurrentSlide(): void {
    // Si no hay items, resetear a 0
    if (this._items.length === 0) {
      this._currentSlide = 0;
      this.updateCurrentSlide.emit(this._currentSlide);
      return;
    }

    // Si el currentSlide está fuera del rango válido, ajustarlo
    if (this._currentSlide >= this._items.length) {
      this._currentSlide = this._items.length - 1;
      this.updateCurrentSlide.emit(this._currentSlide);
      this.resetTimer.emit();
    }
  }

  handlePreviousClick() {
    if (this.firstItemOnCarousel) return;
    const previous = this.currentSlide - 1;
    this.currentSlide = previous < 0 ? this.items.length - 1 : previous;
    this.updateCurrentSlide.emit(this.currentSlide);
    this.resetTimer.emit();
  }

  handleNextClick() {
    if (this.lasItemOnCarousel) return;
    const next = this.currentSlide + 1;
    this.currentSlide = next === this.items.length ? 0 : next;
    this.updateCurrentSlide.emit(this.currentSlide);
    this.resetTimer.emit();
  }

  get firstItemOnCarousel() {
    return this.currentSlide === 0;
  }

  get lasItemOnCarousel() {
    return this.currentSlide === this.items.length - 1;
  }
}
